export const sliderWelcome = {
  dots: true,
  autoplay: true,
  autoplaySpeed: 5000,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  speed: 500,
  arrows: false,
  adaptiveHeight: true,
  appendDots: (dots) => <ul>{dots}</ul>,
  customPaging: (i) => (
    <div className="ft-slick__dots--custom">
      <div className="loading" />
    </div>
  ),
};
